const BENEFICIARIES_LOADED = "BENEFICIARIES_LOADED";
const CLEAR_PANEL = "CLEAR_PANEL";
const ADD_CREDENTIAL_SVG = 'ADD_CREDENTIAL_SVG';
const ADD_RECEIPT_PAYMENT_SVG = 'ADD_RECEIPT_PAYMENT_SVG';
const ERROR_VERSION_MINIMA = 'ERROR_VERSION_MINIMA'
const ADD_MIN_VERSION = "ADD_MIN_VERSION"
const ADD_LAST_VERSION = "ADD_LAST_VERSION"
const ADD_CURR_VERSION = "ADD_CURR_VERSION"
const APP_MOBILE = "APP_MOBILE"

export {
  BENEFICIARIES_LOADED,
  CLEAR_PANEL,
  ADD_CREDENTIAL_SVG,
  ADD_RECEIPT_PAYMENT_SVG,
  ERROR_VERSION_MINIMA,
  ADD_MIN_VERSION,
  ADD_LAST_VERSION,
  ADD_CURR_VERSION,
  APP_MOBILE
};

function setBeneficiariesLoaded() {
  return {
    type: BENEFICIARIES_LOADED,
    panel: {
      beneficiariesLoaded: true,
    }
  }
}

function clearPanel() {
  return {
    type: CLEAR_PANEL,
    panel: {}
  }
}

function addCredentialSVG(credential) {
  return {
    type: ADD_CREDENTIAL_SVG,
    credential,
  }
}

function addReceiptPaymentSVG(receipt) {
  return {
    type: ADD_RECEIPT_PAYMENT_SVG,
    receipt,
  }
}

function setErrorVersion(data){
  return {
    type: ERROR_VERSION_MINIMA,
    panel: {
      errorVersion: data,
    }
  }
}

function addMinVersion(data){
  return {
    type: ADD_MIN_VERSION,
    panel: {
      minVersion: data,
    }
  }
}

function addLastVersion(data){
  return {
    type: ADD_LAST_VERSION,
    panel: {
      lastVersion: data,
    }
  }
}

function addCurrVersion(data){
  return {
    type: ADD_CURR_VERSION,
    panel: {
      currVersion: data,
    }
  }
}

function setAppMobile(data){
  return {
    type: APP_MOBILE,
    panel: {
      app: data,
    }
  }
}

export {
  setBeneficiariesLoaded,
  clearPanel,
  addCredentialSVG,
  addReceiptPaymentSVG,
  setErrorVersion,
  addMinVersion,
  addLastVersion,
  addCurrVersion,
  setAppMobile
}

